"use client";
import ToolsStack from "@/components/section-infographic/DesignAndDevelopmentAsAService/ToolsStack";
import CaseStudiesMutiPurposeZigZagSection from "@/components/ui/CaseStudiesMutiPurposeZigZagSection";
import CaseStudyEngageMentModel from "@/components/ui/CaseStudyEngageMentModel";
import CommentSection from "@/components/ui/CommentSection";
import CTABanner from "@/components/organisms/CTABanner";
import VideoSection from "@/components/ui/VideoSection";

import CaseStudiesIntroBanner from "@/components/ui/CaseStudiesIntroBanner";
import CaseStudiesNewMegaCardSection from "@/components/ui/CaseStudiesNewMegaCarSection";
import CaseStudiesSkewSatusCardsSection from "@/components/ui/CaseStudiesSkewSatusCardsSection";
import ImageMarquee from "@/components/ui/ImageMarquee";
import SectionTitle from "@/components/ui/SectionTitle";
import IndustryHero from "@/components/SectionHero/IndustryHero";

import RelatedCaseStudies from "@/components/ui/RelatedCaseStudies";
import UniversalTable from "@/components/UniversalTable";
import TheChallengeScrollSection from "@/components/ui/TheChallengeScrollSection";

export default function BoardGamesCasestudyPage() {
    const clients = [

        {
            label: "CLIENT",
            name: "Park n Fly",

        },
        {
            label: "INDUSTRY",
            name: "Travel & Transportation",

        },
        {
            label: "Engagement Type",
            description: "Performance Marketing (PPC Management & Conversion) Optimization ",
        },
    ];

    const skewCards = [
        {
            title: "6,700+",
            description: "Conversions Generated in a Single Month",
        },
        {
            title: "62.0%",
            description: "Conversion Rate Achieved",
        },
        {
            title: "19.1%",
            description: "Account-wide CTR",
        },
        {
            title: "NZ$0.58",
            description: "Cost per Conversion",
        },
        {
            title: "10,800+",
            description: "Qualified Clicks",
        },
    ];

    return (
        <main className="overflow-hidden">

            <IndustryHero svgPath="/HeroSectionImg/ParkNFly.svg" />
            <CaseStudiesIntroBanner
                title="Driving High-Volume Conversions Through Strategic Google Ads Optimization"
                subtitle=""
                imageSrc="/logo/ParkNFly.svg"
                imageAlt="Board Games"
            />

            <CaseStudiesSkewSatusCardsSection clients={clients} skewCards={skewCards} clientIntroPara="MMB partnered with Park n Fly to evaluate and optimize its Google Ads ecosystem, uncovering growth opportunities across campaign structure, audience targeting, conversion tracking, and budget allocation. The engagement provided a clear roadmap for scaling bookings while maintaining exceptional acquisition efficiency." />

            <section className=" relative overflow-hidden border-y border-[#EDEDED] ">
                < VideoSection src="/video/ParkNFly.mp4" poster="/Thumbnails/ParkNFly.png" />
            </section>



            <TheChallengeScrollSection
                sectionTitle={{
                    title: "The Challenge",
                    description: [
                        "Park n Fly was generating strong booking volumes through Google Ads, but several account inefficiencies limited further growth. Budget constraints, keyword bloat, incomplete ad assets, and underutilized targeting opportunities prevented the business from maximizing conversion potential and advertising efficiency. "
                    ],
                }}
                rightColumnItems={[
                    {
                        heading: "Budget-Constrained Growth",
                        text: "High-performing campaigns were exhausting daily budgets early, resulting in missed opportunities throughout the day.",
                    },
                    {
                        heading: "Excessive Keyword Bloat",
                        text: "More than 14,000 keywords existed within the account, with thousands generating no impressions or clicks.",
                    },
                    {
                        heading: "Underutilized Audience Signals",
                        text: "No audience observation data was being leveraged to identify valuable traveler segments.",
                    },
                    {
                        heading: "Incomplete Ad Assets",
                        text: "Available headline, description and image extension opportunities remained unused.",
                    },
                    {
                        heading: "Generic Geographic Targeting",
                        text: "High-converting locations were grouped broadly rather than receiving dedicated optimization strategies.",
                    },
                    {
                        heading: "Device Bid Inefficiencies",
                        text: "Mobile traffic generated the majority of conversions but lacked dedicated bid adjustments.",
                    },
                    {
                        heading: "Conversion Tracking Limitations",
                        text: "Enhanced Conversions were not enabled, reducing attribution accuracy and optimization effectiveness.",
                    },
                ]}
            />
            <div className=" py-16 lg:py-24  relative overflow-hidden">

                <CaseStudiesMutiPurposeZigZagSection
                    sectionTitle="Our Strategic Approach"
                    sectionDescription="MMB implemented a performance-led PPC optimization strategy focused on improving campaign efficiency, strengthening audience intelligence, enhancing conversion tracking, and identifying scalable opportunities for long-term growth. "

                    cards={[
                        {
                            iconSrc: "/icons/StrategicApproach-icon/ParkNFly (4).svg",
                            iconAlt: "Budget Optimization",
                            title: "Budget Optimization",
                            description: "Focused on improving campaign efficiency through budget allocation, keyword refinement, campaign prioritization, and performance optimization.",
                            contentAlign: "center"
                        },
                        {
                            iconSrc: "/icons/StrategicApproach-icon/ParkNFly (2).svg",
                            iconAlt: "Audience & Market Intelligence",
                            title: "Audience & Market Intelligence",
                            description: "Analyzed user behavior, demographics, devices, and locations to identify the segments generating the highest booking volume and conversion efficiency.",
                        },
                        {
                            iconSrc: "/icons/StrategicApproach-icon/ParkNFly (1).svg",
                            iconAlt: "Ad Experience Optimization",
                            title: "Ad Experience Optimization",
                            description: "Enhanced ad relevance, visibility, and engagement through creative improvements, asset expansion, and ad strength optimization. ",
                            contentAlign: "center"
                        },
                        {
                            iconSrc: "/icons/StrategicApproach-icon/ParkNFly (3).svg",
                            iconAlt: "Conversion Intelligence  ",
                            title: "Conversion Intelligence",
                            description: "Strengthened measurement accuracy and bidding intelligence to improve optimization decisions and support long-term account scalability.",
                            contentAlign: "center"
                        },


                    ]}
                />

            </div>

            <div className="custom-container pb-16 lg:pb-20 xl:pb-24">


                <CaseStudyEngageMentModel
                    leftImage="/hero-bg/officemeet.jpg"
                    cards={[
                        {
                            title: "Delivery Model",
                            description: [
                                "PPC Optimization & Growth Management",
                            ],
                        },
                        {
                            title: "Team Structure ",
                            description: [
                                "PPC Strategist, Performance Analyst, Conversion Specialist ",
                            ],
                        },

                        {
                            title: "Reporting Frequency",
                            description: [
                                "Monthly Performance Reviews",
                            ],
                        },
                        {
                            title: "Optimization Cycle ",
                            description: [
                                "Continuous Monitoring & Refinement",
                            ],
                        },


                    ]}


                />




            </div>


            <div className="section-background-filler py-16 space-y-16">
                <CaseStudiesNewMegaCardSection
                    sectionTitle={{
                        title: "What We Did ",
                        description: "We implemented a data-driven, multi-channel strategy to bridge gaps in technical infrastructure, local visibility, and content, building a unified engine that captures intent and drives consistent revenue growth.",
                        align: "left"
                    }}
                    cards={[
                        {
                            title: "Account Audit",
                            description:
                                "Conducted a full performance review across campaigns, keywords, audiences and conversion tracking.",
                        },
                        {
                            title: "Budget Optimization",
                            description:
                                "Identified budget-limited campaigns and recommended budget expansion for growth-driving campaigns.",
                        },
                        {
                            title: "Keyword Cleanup",
                            description:
                                "Evaluated more than 14,000 keywords and isolated non-performing segments for removal.",
                        },
                        {
                            title: "Device Optimization",
                            description:
                                "Analyzed device-level performance and identified mobile as the primary conversion driver.",
                        },
                        {
                            title: "Ad Scheduling",
                            description:
                                "Mapped conversion trends across days and hours to identify peak-performing windows.",
                        },
                        {
                            title: "Geographic Targeting",
                            description:
                                "Segmented top-performing locations including Auckland and Auckland Airport.",
                        },
                        {
                            title: "Demographic Analysis",
                            description:
                                "Isolated high-converting age groups and developed bid adjustment recommendations.",
                        },
                        {
                            title: "Ad Asset Enhancement",
                            description:
                                "Expanded headline, description, and extension opportunities to improve visibility.",
                        },
                        {
                            title: "Audience Strategy",
                            description:
                                "Introduced audience observation opportunities for traveler-based targeting.",
                        },
                        {
                            title: "Conversion Tracking",
                            description:
                                "Recommended Enhanced Conversions implementation for improved attribution accuracy.",
                        },
                        {
                            title: "Bidding Strategy Review",
                            description:
                                "Evaluated transition opportunities from Maximize Conversions to Maximize Conversion Value.",
                        },
                    ]}

                />

                <ImageMarquee
                    images={[
                        { src: "/CaseStudiesFolder/ShowCaseImg/ParkNFly-ShowCaseImages/ShowCaseImg (2).png", alt: "Jem Jem case study" },
                        { src: "/CaseStudiesFolder/ShowCaseImg/ParkNFly-ShowCaseImages/ShowCaseImg (1).png", alt: "Jem Jem case study" },
                        { src: "/CaseStudiesFolder/ShowCaseImg/ParkNFly-ShowCaseImages/ShowCaseImg (3).png", alt: "Jem Jem case study" },
                    ]}
                    speed={20}
                    direction="left"
                    pauseOnHover={false}
                />


            </div>



            <section className="py-16 lg:py-20 custom-container">
                <SectionTitle
                    title="The Results "
                    description="Performance measured across visibility, engagement, conversions, and business growth.  "
                    align="center"
                    highlightSubtitle={true}
                />


                <div className="w-full overflow-x-auto mt-6">
                    <div className="inline-block min-w-full align-middle">
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 !text-left ">

                            <div className="col-span-2"> <UniversalTable
                                title="Campaign Performance"
                                headers={["Metric", "Performance"]}
                                rows={[
                                    [
                                        "Total Qualified Clicks Generated",
                                        "10.8K+",
                                    ],
                                    [
                                        "Total Search Impressions",
                                        "56.6K+",
                                    ],
                                    [
                                        "Average Click-Through Rate",
                                        "19.1%",
                                    ],
                                    [
                                        "Total Customer Conversions",
                                        "6.7K+",
                                    ],
                                    [
                                        "Overall Conversion Rate Achieved",
                                        "62.0%",
                                    ],
                                    [
                                        "Total Google Ads Investment",
                                        "NZ$3.88K",
                                    ],
                                    [
                                        "Average Cost Per Click",
                                        "NZ$0.36",
                                    ],
                                    [
                                        "Average Cost Per Conversion",
                                        "NZ$0.58",
                                    ],
                                ]}
                                ribbonTitle="Key Insight"
                                ribbonContent="High engagement and conversion rates demonstrated strong alignment between user intent, campaign targeting and ad messaging."
                            />
                            </div>
                            <div className="col-span-2">
                                <UniversalTable
                                    title="Top Campaign Performance"
                                    headers={["Campaign", "CTR", "Avg. CPC", "Cost/Conversion"]}
                                    rows={[
                                        [
                                            "Branded Campaign",
                                            "31.28%",
                                            "NZ$0.32",
                                            "NZ$0.56",
                                        ],
                                        [
                                            "Lead Campaign",
                                            "16.86%",
                                            "NZ$0.46",
                                            "NZ$0.60",
                                        ],
                                        [
                                            "Search Max Clicks",
                                            "16.08%",
                                            "NZ$0.23",
                                            "NZ$0.55",
                                        ],
                                        [
                                            "DSA Search",
                                            "11.11%",
                                            "NZ$0.15",
                                            "NZ$0.86",
                                        ],
                                        [
                                            "Search Parking",
                                            "5.69%",
                                            "NZ$0.25",
                                            "NZ$0.57",
                                        ],
                                    ]}
                                    ribbonTitle="Key Insight"
                                    ribbonContent="Branded search campaigns consistently generated the strongest performance, while supporting search campaigns expanded reach at highly efficient acquisition costs."
                                /></div>

                            <UniversalTable
                                title="Audience & Targeting Insights"
                                headers={["Segment", "Performance"]}
                                rows={[
                                    [
                                        "Top Device",
                                        "Mobile",
                                    ],
                                    [
                                        "Mobile Clicks",
                                        "4,737+",
                                    ],
                                    [
                                        "Highest-Converting Age Group",
                                        "25–34",
                                    ],
                                    [
                                        "Cost Per Conversion (25–34)",
                                        "NZ$0.70",
                                    ],
                                    [
                                        "Best Performing Day",
                                        "Thursday",
                                    ],
                                    [
                                        "Peak Conversion Rate",
                                        "6.41%",
                                    ],
                                ]}
                                ribbonTitle="Key Insight"
                                ribbonContent="Mobile users and travelers aged 25–34 represented the most valuable audience segments. Strategic bid adjustments toward these groups presented significant opportunities for incremental growth."
                            />
                            <UniversalTable
                                title="Overall Business Impact"
                                headers={["Growth Area", "Impact"]}
                                rows={[
                                    [
                                        "Lead Generation",
                                        "6,700+ Monthly Conversions",
                                    ],
                                    [
                                        "Acquisition Efficiency",
                                        "NZ$0.58 Cost Per Conversion",
                                    ],
                                    [
                                        "Search Visibility",
                                        "19.1% CTR Across Campaigns",
                                    ],
                                    [
                                        "Audience Engagement",
                                        "10,800+ Qualified Clicks",
                                    ],
                                    [
                                        "Conversion Performance",
                                        "62% Conversion Rate",
                                    ],
                                    [
                                        "Growth Readiness",
                                        "Clear Optimization Roadmap Identified",
                                    ],
                                ]}
                                ribbonTitle="Key Insight"
                                ribbonContent="Data-driven optimization positioned the account for continued booking growth while preserving exceptional advertising efficiency."
                            />
                            <div className="col-span-2">
                                <UniversalTable
                                    title="Geographic Performance"
                                    headers={["Location", "Conversions"]}
                                    rows={[
                                        [
                                            "Auckland",
                                            "1,036+",
                                        ],
                                        [
                                            "Auckland Airport",
                                            "496+",
                                        ],
                                        [
                                            "High-Performing Suburbs & Postal Zones",
                                            "Significant Conversion Density",
                                        ],
                                    ]}
                                    ribbonTitle="Key Insight"
                                    ribbonContent="Conversion activity was concentrated around major travel hubs, creating opportunities for location-specific bidding strategies and hyper-local campaign expansion."
                                />
                            </div>


                        </div>
                    </div>
                </div>

            </section>





            <CommentSection quote="MMB's approach went beyond campaign management. Their team identified growth opportunities that were hidden within our existing Google Ads account and provided a clear strategy to improve efficiency, targeting, and conversion performance. The insights delivered helped us better understand our customers, optimize our marketing spend, and create a stronger foundation for future growth." name="Park N Fly" avatarSrc={""} />

            <ToolsStack
                title="Our Tech Stack & Tools "
                description="We deployed an agile, high-performance toolkit for SEO, analytics, and paid media to support scalable operations, ensuring data-driven decision-making and continuous optimization across every customer touchpoint."
                categories={[
                    {
                      title: "Geographic & Campaign Optimization",
                      items: [
                        "Google Ads Location Reports",
                        "Google Ads Recommendations",
                        "Ad Strength Analysis",
                      ],
                    },
                    {
                      title: "Bid & Budget Management",
                      items: [
                        "Smart Bidding",
                        "Target CPA",
                        "Maximize Conversions",
                      ],
                    },
                    {
                      title: "Keyword Research & Optimization",
                      items: [
                        "Google Keyword Planner",
                        "Search Terms Report",
                      ],
                    },
                    {
                      title: "Analytics & Measurement",
                      items: [
                        "Google Analytics 4",
                        "Google Tag Manager",
                      ],
                    },
                    {
                      title: "Reporting & Visualization",
                      items: [
                        "Looker Studio",
                        "Google Ads Dashboard",
                        "Search Query Analysis"
                      ],
                    },
                    {
                      title: "Conversion Tracking",
                      items: [
                        "Google Ads Conversion Tracking",
                        "Enhanced Conversions",
                      ],
                    },
                    {
                      title: "Audience Insights",
                      items: [
                        "Google Ads Audience Manager",
                      ],
                    },
                    {
                      title: "Paid Advertising",
                      items: [
                        "Google Ads",
                      ],
                    },
                   
                  ]}
                withBackground={true}
            />


            <div className="pb-0 md:pb-16 xl:pb-20 relative overflow-hidden">
                <CTABanner
                    title="Looking to Drive More Traffic, Customers, and Sales? "
                    description="Let's Build Your Growth Engine! "
                    buttonText="Speak with an Expert "
                    // buttonOnClick={handleCTAButtonClick}
                    bgColor="#313866"
                    textColor="#fff"
                    buttonVariant="primary"
                />
            </div>
            <RelatedCaseStudies />
        </main >
    );
}